<template>
  <transition name="modal">
    <div class="modal" v-if="showModal" @click="onClose">
      <div class="modal-container" @click.stop>
        <button class="btn btn--mobile-close" @click="onClose"><span class="icon-remove"></span></button>
        <component :is="currentModal" :args="args" />
      </div>
    </div>
  </transition>
</template>

<script>  
  /*
   Dashboard
   */
  import TaskAssigneeDesignerModal from 'components/pages/project/task/modals/TaskAssigneeDesignerModal'
  
  /*
   Projects
   */
  import ProjectRemoveModal from 'components/pages/projects/modals/ProjectRemoveModal'
  import ProjectCreateModal from 'components/pages/projects/modals/ProjectCreateModal'
  import ProjectArchiveModal from 'components/pages/projects/modals/ProjectArchiveModal'

  /*
   Project
   */
  import ProjectRemoveUserModal from 'components/pages/project/modals/RemoveUserModal'
  import ProjectSettingsModal from 'components/pages/project/modals/ProjectSettingsModal'
  import ProjectTopUpModal from 'components/pages/project/modals/ProjectTopUpModal'
  import ProjectTeamModal from 'components/pages/project/modals/ProjectTeamModal'
  import DownloadZipModal from 'components/pages/project/modals/DownloadZipModal'
  import ClientCharacterNotes from 'components/pages/project/modals/ClientCharacterNotes'

  /* Task */
  import ProjectRemoveTaskModal from 'components/pages/project/modals/RemoveTaskModal'
  import ProjectRemoveTaskDesignerFilesModal from 'components/pages/project/modals/RemoveDesignerFilesModal'
  import ProjectRemoveTaskDescriptionFilesModal from 'components/pages/project/modals/RemoveDescriptionFilesModal'
  import TaskUploadDesignerFilesModal from 'components/pages/project/task/modals/UploadDesignerFilesModal'
  import TaskUpdateStatusModal from 'components/pages/project/task/modals/UpdateStatusModal'

  /*
   User
   */
  import RemoveAllUserInformation from 'components/pages/user/modals/RemoveAllUserInformation'
  
  /*
   Users
   */
  import AddUserModal from 'components/pages/users/modals/AddUserModal'
  import UpdateUserModal from 'components/pages/users/modals/UpdateUserModal'
  import RemoveUserModal from 'components/pages/users/modals/RemoveUserModal'
  import PaymentUserModal from 'components/pages/users/modals/PaymentUserModal'

  /*
   Gallery
   */
  import GalleryRemoveCommentModal from 'components/common/gallery/GalleryRemoveCommentModal'

  /*
   Common Modals
   */
  import UserInfoModal from 'components/common/modals/UserInfoModal'

  export default {
    name: 'modal',

    data () {
      return {
        showModal: false,
        currentModal: null,
        args: null
      }
    },

    components: {
      /*
       * Dashboard
       * */
      'project-remove-modal': ProjectRemoveModal,
      'project-archive-modal': ProjectArchiveModal,

      /*
       * DashboardNew
       * */
      'task-assignee-designer-modal': TaskAssigneeDesignerModal,

      /*
       * Project
       * */
      'project-remove-user-modal': ProjectRemoveUserModal,
      'project-settings-modal': ProjectSettingsModal,
      'project-top-up-modal': ProjectTopUpModal,
      'project-team-modal': ProjectTeamModal,
      'project-create-modal': ProjectCreateModal,
      'download-zip-modal': DownloadZipModal,
      'clients-character-notes': ClientCharacterNotes,

      /* Project Task */
      'project-remove-task-modal': ProjectRemoveTaskModal,
      'project-remove-task-designer-files-modal': ProjectRemoveTaskDesignerFilesModal,
      'project-remove-task-description-files-modal': ProjectRemoveTaskDescriptionFilesModal,
      'task-upload-designer-files-modal': TaskUploadDesignerFilesModal,
      'task-update-status-modal': TaskUpdateStatusModal,

      /*
       * User
       * */
      'add-user-modal': AddUserModal,
      'update-user-modal': UpdateUserModal,
      'remove-user-modal': RemoveUserModal,
      'payment-user-modal': PaymentUserModal,
      
      /*
       * User
       *  Settings */
      'remove-all-user-information': RemoveAllUserInformation,

      /*
       * Common
       * */
      /* Gallery */
      'gallery-remove-comment-modal': GalleryRemoveCommentModal,

      /* Common */
      'user-info-modal': UserInfoModal
    },

    methods: {
      onModalClose (event) {
        return event.keyCode === 27 
          ? this.onClose() 
          : false
      },

      /*
       * On Show
       * @param {string} component A name of the modal component which you want to show
       * @param {object} args An object with arguments passed from injected modal components to main modal component,
       * can be a simple property or something else as an object as well
       * */
      onShow ([component, args]) {
        this.showModal = true
        this.currentModal = component
        this.args = args

        /* Emit body overflow to prevent scroll */
        this.$bus.$emit('bodyOverflow')
      },

      /*
       * On Close
       * */
      onClose () {
        /* If modal is showed, emit body overflow to allow user to scroll again */
        if (this.showModal) {
          this.$bus.$emit('bodyOverflow')
        }
        this.showModal = false
      }
    },

    created () {
      window.addEventListener('keyup', this.onModalClose)
    },
    beforeDestroy () {
      window.removeEventListener('keyup', this.onModalClose)
    }
  }
</script>



// WEBPACK FOOTER //
// Modal.vue?e009043c